import React, { useState, useEffect } from "react";
import { api } from "../../../utlis/admin/api.utlis";
import ApiService from "../../../core/services/ApiService";
import Loader from "../../../layouts/loader/Loader";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";

const Page = () => {
  const [loading, setLoading] = useState(false);
  const [typePassword1, setTypePassword1] = useState(true);
  const [typePassword2, setTypePassword2] = useState(true);
  const [typePassword3, setTypePassword3] = useState(true);

  const initialValues = {
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  };

  const validationSchema = Yup.object().shape({
    currentPassword: Yup.string().required("Current password is required"),
    newPassword: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .matches(/[A-Z]/, "Must include at least one uppercase letter")
      .matches(/[a-z]/, "Must include at least one lowercase letter")
      .matches(/\d/, "Must include at least one number")
      .matches(/[@$!%*?&]/, "Must include at least one special character")
      .required("New password is required"),
    confirmNewPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
      .required("Confirm password is required"),
  });

  const changePassword = async (formValue) => {
    setLoading(true);
    const form = JSON.stringify({
      currentPassword: formValue.currentPassword,
      newPassword: formValue.newPassword,
      confirmNewPassword: formValue.confirmNewPassword,
    });
    const response = await ApiService.postAPIWithAccessToken(
      api.changePassword,
      form
    );
    if (response.data.status) {
      toast.success(response.data.message);
      document.getElementById("change-password-form").reset();
    } else {
      toast.error(response.data.message);
      document.getElementById("change-password-form").reset();
    }
    setLoading(false);
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="content-wrapper">
        <div className="page-header">
          <h3 className="page-title">Change Password</h3>
        </div>
        <div className="row">
          <div className="col-md-12">
            <Formik
              initialValues={initialValues}
              validateOnChange={true}
              validationSchema={validationSchema}
              onSubmit={changePassword}
            >
              <Form className="findcare-form row" id="change-password-form">
                <div className="col-md-4">
                  <div className="form-group">
                    <h4>Current Password</h4>
                    <div style={{ position: "relative" }}>
                      <Field
                        type={typePassword1 == true ? "password" : "text"}
                        className="form-control form-control-lg mt-2"
                        name="currentPassword"
                        placeholder="Enter Current Password"
                      />
                      <span
                        onClick={() => setTypePassword1(!typePassword1)}
                        style={{
                          position: "absolute",
                          top: "31%",
                          right: "7%",
                          cursor: "pointer",
                        }}
                      >
                        <i
                          style={{ color: "#000" }}
                          className={
                            typePassword1 == true
                              ? "fa fa-eye-slash"
                              : "fa fa-eye"
                          }
                        ></i>
                      </span>
                    </div>
                    <ErrorMessage
                      name="currentPassword"
                      component="div"
                      className="alert alert-danger"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <h4>New Password</h4>
                    <div style={{ position: "relative" }}>
                      <Field
                        type={typePassword2 == true ? "password" : "text"}
                        className="form-control form-control-lg mt-2"
                        name="newPassword"
                        placeholder="Enter Confirm Password"
                      />

                      <span
                        onClick={() => setTypePassword2(!typePassword2)}
                        style={{
                          position: "absolute",
                          top: "31%",
                          right: "7%",
                          cursor: "pointer",
                        }}
                      >
                        <i
                          style={{ color: "#000" }}
                          className={
                            typePassword2 == true
                              ? "fa fa-eye-slash"
                              : "fa fa-eye"
                          }
                        ></i>
                      </span>
                    </div>
                    <ErrorMessage
                      name="newPassword"
                      component="div"
                      className="alert alert-danger"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <h4>Re-Enter New Password</h4>
                    <div style={{ position: "relative" }}>
                      <Field
                        type={typePassword3 == true ? "password" : "text"}
                        className="form-control form-control-lg mt-2"
                        name="confirmNewPassword"
                        placeholder="Re-Enter New Password"
                      />
                      <span
                        onClick={() => setTypePassword3(!typePassword3)}
                        style={{
                          position: "absolute",
                          top: "31%",
                          right: "7%",
                          cursor: "pointer",
                        }}
                      >
                        <i
                          style={{ color: "#000" }}
                          className={
                            typePassword3 == true
                              ? "fa fa-eye-slash"
                              : "fa fa-eye"
                          }
                        ></i>
                      </span>
                    </div>
                    <ErrorMessage
                      name="confirmNewPassword"
                      component="div"
                      className="alert alert-danger"
                    />
                  </div>
                </div>
                <div className="form-group text-end">
                  <button
                    type="submit"
                    className="btn-gr"
                    data-bs-dismiss="modal"
                  >
                    Change
                  </button>
                </div>
              </Form>
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default Page;
